import { v4 as uuid } from 'uuid';

import { FormattedTransactions } from '@eika/transaction-list/src/TransactionList';

import type { Account, EFaktura } from '../../generated-types';

const createAccount = (partialAccount: Partial<Account> = {}): Account => ({
    accountId: { value: uuid() },
    accountNumber: { value: '12345678910' },
    alias: 'Spending account',
    balance: { accountingBalance: 10000, availableBalance: 10000, creditLimit: 0 },
    bank: { bankregnr: { value: '0770' } },
    coreProduct: '',
    currency: 'NOK',
    favorite: true,
    owners: [],
    rights: { paymentFrom: false, transferFrom: false, transferTo: false },
    status: 'UNKNOWN',
    type: 'CLIENT_ACCOUNT',
    additionalInfo: {},
    ...partialAccount,
});

export const favoriteAccount: Account = createAccount({
    alias: 'Spending account',
});

const createEFakturaData = (partial: Partial<EFaktura> = {}): EFaktura => ({
    amount: 200,
    issuerName: 'Elkjop.no',
    kid: { value: '1254585' },
    fromAccount: favoriteAccount.accountNumber,
    toAccountNumber: { value: '12345452' },
    eFakturaReference: '123456',
    permission: {
        canEdit: false,
        canView: false,
        canReject: false,
    },
    issuerId: '1234567',
    agreementId: { value: '1234' },
    minimumAmount: 123,
    efakturaType: 'EFAKTURA',
    currency: 'NOK',
    id: { value: '12345678' },
    paymentDate: '2025-09-28',
    notificationDate: '2024-12-23',
    status: 'NEW',
    ...partial,
});

export const visibleAccounts: Account[] = [
    favoriteAccount,
    createAccount({
        alias: 'Savings account',
        balance: { accountingBalance: 124548, availableBalance: 124548, creditLimit: 0 },
        accountNumber: { value: '1234565432' },
    }),
];

export const transactions: FormattedTransactions[] = [
    {
        id: '123',
        label: 'April 2021',
        transactions: [
            {
                id: '1231',
                description: 'Apple Store',
                date: '30.04.21',
                amount: '16 990,00',
                deposit: false,
                reservation: true,
            },
        ],
    },
    {
        id: '124',
        label: 'March',
        transactions: [
            {
                id: '1231',
                description: 'Pepsi and a burger',
                date: '12.03.21',
                amount: '1 024,00',
                deposit: false,
                reservation: false,
            },
            {
                id: '1232',
                description: 'Eika Gruppen',
                date: '01.03.21',
                amount: '42 0012,00',
                deposit: true,
                reservation: false,
            },
            {
                id: '1233',
                description: 'Apple Store',
                date: '01.03.21',
                amount: '1 990,00',
                deposit: false,
                reservation: false,
            },
        ],
    },
];

export const eFakturas: EFaktura[] = [createEFakturaData()];
